import { createSelector } from 'reselect'

export const userIsLoggedIn = createSelector(
  state => state.auth.loggedIn,
  loggedIn => loggedIn
)

export const userIsLogginIn = createSelector(
  state => state.auth.logginIn,
  logginIn => logginIn
)

export const authChecked = createSelector(
  state => state.auth.authChecked,
  authChecked => authChecked
)



// WEBPACK FOOTER //
// ./src/selectors/auth.js